import { useCallback } from "react"
import { PropTypes } from "prop-types"

import useFastField from "../useFastField"
import EmailField from "."

/**
 * Wrapper for the EmailField component to let Formik handle the form state
 *
 * @export {function} EmailFieldWrapper
 * @param {object} props EmailFieldWrapper props
 * @returns {function} EmailFieldWrapper
 */
export default function EmailFieldWrapper({ name, ...rest }) {
  const { field, error, helpers, touched } = useFastField(name)
  const { setTouched, setValue } = helpers
  const onChange = useCallback((key, value) => setValue(value), [setValue])
  const onBlur = useCallback(() => setTouched(true), [setTouched])

  return (
    <EmailField
      {...field}
      error={error}
      onBlur={onBlur}
      onChange={onChange}
      touched={field.value ? touched : false}
      {...rest}
    />
  )
}

EmailFieldWrapper.propTypes = {
  name: PropTypes.string.isRequired
}
